import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import StoryCard from '../components/storyComponents/StoryCard';
import SharedStoryCard from '../components/sharedStory/SharedStoryCard';
import HomeStories from '../components/storyComponents/HomeStories';
import SharedStoryBtn from '../components/SharedStoryBtn';
import { loadStory, loadHomeStories, loadSharedStories } from '../actions';
import SocialShareButtons from '../components/SocialShareButtons';
import { push, replace } from 'react-router-redux';
import { asyncActions } from 'react-async-actions';
import { filter } from 'lodash/collection';


const splitCopyIntoParagraphs = (content) => {
  content = content.split(/\n\s*\n/g).map(line => `<p>${line}</p>`).join('');

  return content
}

const YouTubeVideo = (id, width, height) => (
    <div className="youtube-wrapper">
        <div className="youtube">
            <iframe style={{border:0}} width={`${width}`} height={`${height}`}
                className="youtube-frame"
                src={`https://www.youtube.com/embed/${id}?autoplay=0`}
                allowFullScreen
            />
        </div>
    </div>
);

const FBVideo = (id, width, height) => (
    <div className="youtube-wrapper">
        <div className="youtube">
            <iframe src={`https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fr29anomaly%2Fvideos%2F${id}%2F&show_text=0&width=${width}`} width={`${width}`} height={`${height}`}  style={{border: 'none', overflow: 'hidden'}} scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
        </div>
    </div>
);

const actionsToFire = (props) => [
  props.loadHomeStories(),
  props.loadSharedStories(),
  props.loadStory(props.params.id)
]

@asyncActions(actionsToFire)
class StoryDetail extends Component {
  state = {
    bannerWidth: '',
    bannerHeight: ''
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.props.loadStory(nextProps.params.id)
    }
  }
  componentWillMount() {
    this.props.loadHomeStories();
    this.props.loadSharedStories();
    this.props.loadStory(this.props.router.params.id);

    let bannerWidth = '';
    let bannerHeight = '';
    if (this.props.browser.greaterThan.desktop) {
      bannerWidth = 640;
      bannerHeight = 360;
    } else { // We are in mobile
      bannerWidth = this.props.browser.width;
      bannerHeight = Math.round(bannerWidth / 1.777);
    }

    this.setState({bannerWidth: bannerWidth, bannerHeight: bannerHeight})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.props.loadStory(this.props.router.params.id);
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  mergeStories = (homeStories, sharedStories) => {
    // Merge home stories with shared stories into allStories
    var allStories = homeStories.concat(sharedStories);
    return allStories;
  }

  sortStories = (allStories) => {
    // Sort homeStories by js_date which pulls from status_changed in backend
        allStories.sort(function(a, b){
          var dateA = a.js_date, dateB = b.js_date;
          if (dateA > dateB) {
            return -1;
          }
          if (dateA < dateB) {
            return 1;
          }
          return 0;
        });

        return allStories;
  }

  render() {

    let isLoaded = this.props.userStoryDetail.isLoaded;
    if (!isLoaded) {
      return <span />;
    }

    let homeStoriesLoaded = this.props.homeStories.isLoaded;
    if (!homeStoriesLoaded) {
      return <span />;
    }

    let storyDetailId = this.props.userStoryDetail.id;
    let bylinePrefix = this.props.userStoryDetail.which_byline_attr;
    let bannerImg = this.props.userStoryDetail.image_cover;
    let storyTitle = this.props.userStoryDetail.storyTitle;
    let storyId = this.props.userStoryDetail.id;
    let content = this.props.userStoryDetail.storyCopy;
    let isExternalAsset = this.props.userStoryDetail.is_external_asset;
    let externalAssetName = this.props.userStoryDetail.external_asset_name;

    let bannerUrl = '';
    bannerUrl = this.props.userStoryDetail.bannerUrl;
    let orgLogo = '';
    let orgDetailPageId = '';
    orgDetailPageId = this.props.userStoryDetail.organization;

    let orgDetailPageUrl = '';
    if (orgDetailPageId != '') {
      orgDetailPageUrl = '/organizations/' + orgDetailPageId;
    }



    let storyCopy = '';
    let author = '';
    let thumbnailText = '';
    thumbnailText = this.props.userStoryDetail.storyThumbnailCopy;
    let authorObj = '';
    let path = this.props.router.location.pathname;
    let youtubeVideoId = this.props.userStoryDetail.youtubeVideoId;
    let facebookVideoId = this.props.userStoryDetail.facebookVideoId;
    let banner = '';
    let bannerWidth = '';
    let bannerHeight = '';

    bannerWidth = this.state.bannerWidth;
    bannerHeight = this.state.bannerHeight;



    // Test if there is a youtube, fb video or a simple image
    // If bannerUrl is not empty then wrap the banner image in
    // a link to an external site.
    if (youtubeVideoId != null && youtubeVideoId != '') {
      banner = YouTubeVideo(youtubeVideoId, bannerWidth, bannerHeight);
    } else if (facebookVideoId != null && facebookVideoId !='') {
      banner = FBVideo(facebookVideoId, bannerWidth, bannerHeight);
    } else if (bannerImg != null && bannerUrl != '') {
      banner = <a href={bannerUrl} target="_blank"><img src={bannerImg} /></a>
    } else if (bannerImg != null) {
      banner = <img src={bannerImg} />
    }


    function buildByLine(prefix, authorName, orgName) {
      if (prefix == 'by') {
        byLineObj = <div>
          By <Link to={`${orgDetailPageUrl}`}>{`${authorName}`}</Link>
        </div>;
      } else if (prefix == 'via') {
        // Test if this story/asset is external to www
        if (isExternalAsset && bannerUrl !== '') {
          byLineObj = <div>
            Via <a target="_blank" href={bannerUrl}>{externalAssetName}</a>
          </div>;
        } else {
          byLineObj = <div>
            Via <Link to={`${orgDetailPageUrl}`}>{`${orgName}`}</Link>
          </div>;
        }

      }

      return byLineObj;
    }

    let byLineObj = '';
    let userName = '';
    let orgName = '';
    orgName = this.props.userStoryDetail.organization_name;
    userName = this.props.userStoryDetail.full_name;
    byLineObj = buildByLine(bylinePrefix, userName, orgName);


    function buildBioFooter(bylinePrefix, userName, userBio, userPicUrl, orgName, orgBio, orgLogo) {
      if (bylinePrefix == 'by') { // it's a person
        var userPicObj = '';
        // Test if there is a user pic available
        if (userPicUrl == '') {
          userPicObj = '';
        } else {
          userPicObj = <div className="storyDetail-authorPhoto">
            <img src={`${userPicUrl}`} />
          </div>
        }
        // ********** END userPicUrl Conditions *************

        bioFooterObj = <div className="storyDetail-authorWrapper">
          {userPicObj}
          <div className="storyDetail-authorBio">
            <span className="storyDetail-author">{userName}</span> // {userBio}
          </div>
        </div>
      } else if (bylinePrefix == 'via') {
        bioFooterObj = <div className="storyDetail-authorWrapper">
          <div className="storyDetail-authorPhoto">
            <Link to={`${orgDetailPageUrl}`}><img src={orgLogo} /></Link>
          </div>
          <div className="storyDetail-authorBio">
            <span className="storyDetail-author"><Link to={`${orgDetailPageUrl}`}>{orgName}</Link></span> // {orgBio}
          </div>
        </div>
      }

      return bioFooterObj;
    }


    let orgBio = ''; // Organization thumbnail copy
    orgBio = this.props.userStoryDetail.organization_thumbnail_text;
    userPicUrl = this.props.userStoryDetail.user_picUrl;
    let userPicUrl = '';
    userPicUrl = this.props.userStoryDetail.user_picUrl;
    orgLogo = this.props.userStoryDetail.organization_logo;
    let userBio = '';
    userBio = this.props.userStoryDetail.userBio;

    let bioFooterObj = ''; // Finished footer with markup
    if (!isExternalAsset) {
      bioFooterObj = buildBioFooter(bylinePrefix, userName, userBio, userPicUrl, orgName, orgBio, orgLogo);
    }



    let allStories = this.mergeStories(this.props.homeStories, this.props.sharedStories);

    let sortedStories = this.sortStories(allStories);

    sortedStories = filter(sortedStories, function(obj) {
      return obj.id !== storyDetailId.id;
    })

    let storyList = '';

    storyList = sortedStories.map((story, index) => {
      if (index <= 5) {
        if (story.story_type == 'shared_story') { // filter by shared_story but not the featured story
          return <div className="homeStories-storyCardWrapper">
                      <SharedStoryCard
                        key={story.id}
                        sharedstory={story}
                        browser={this.props.browser}
                      />
                    </div>;
        } else if (story.story_type == 'news') {
          return <div className="homeStories-storyCardWrapper">
                      <StoryCard
                        key={story.id}
                        story={story}
                        browser={this.props.browser}
                      />
                    </div>;
        }
      }

    });


    function createMarkup(content) {
      var splitCopy = splitCopyIntoParagraphs(content);
      return { __html: splitCopyIntoParagraphs(content).split('\n').join('<br/>') };
    }

    storyCopy = createMarkup(content);
    storyCopy = <div className="story-copy" dangerouslySetInnerHTML={createMarkup(content)}></div>;

    let meta = {
      title: `WorldWideWomen | ${storyTitle}`,
      description: `${thumbnailText}`,
      canonical: `https://worldwidewomen.co/story/${storyId}`,
      meta: {
        property: {
          'og:type': 'article',
          'og:image': `${bannerImg}`,
          'og:title': `WorldWideWomen | ${storyTitle}`,
          'og:description': `${thumbnailText}`,
          'og:site_name': 'WorldWideWomen',
          'og:url': `https://worldwidewomen.co/story/${storyId}`
        }
      },
      auto: {
        ograph: true,
      },
    }

    return(
      <main>
        <div>
        <DocumentMeta {...meta} />
          <div className="content-wrapper">
            <div className="storyDetail-wrapper">
              <div className="storyDetail-bannerWrapper">
                <div className="storyDetail-banner">
                  {banner}
                </div>

                <div className="storyDetail-titleWrapperOuter">
                  <div className="storyDetail-titleWrapper">
                    <h4>{storyTitle}</h4>
                    <div className="storyDetail-byline">
                      {byLineObj}
                    </div>

                    <div className="storyDetail-socialShareBtnWrapper">
                      <SocialShareButtons
                        storyTitle={storyTitle}
                        path={path}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="storyDetail-copyWrapper">
                {storyCopy}

                {bioFooterObj}

              </div>

              <div className="sharedStoryBtn-wrapper">
                <SharedStoryBtn />
              </div>

            </div>
          </div>




          <div className="storyDetail-storyCardWrapperOuter">
            <div className="content-wrapper">
              <div className="storyDetail-storyCardHeader">
                YOU MIGHT ALSO LIKE...
              </div>
              <div className="storyDetail-storyCardsInnerWrapper">
                {storyList}
              </div>
            </div>
          </div>


        </div>
      </main>
    )
  }
}



function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadStory,
    loadSharedStories,
    loadHomeStories
  }
)(StoryDetail);



// WEBPACK FOOTER //
// ./src/containers/StoryDetail.jsx